import * as FlightPrice from './components/FlightPrice.css';

export default {
	FlightPrice
};
